import { render, staticRenderFns } from "./_UserTask.vue?vue&type=template&id=b8adc592&scoped=true&"
import script from "./_UserTask.vue?vue&type=script&lang=js&"
export * from "./_UserTask.vue?vue&type=script&lang=js&"
import style0 from "./_UserTask.vue?vue&type=style&index=0&id=b8adc592&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8adc592",
  null
  
)

export default component.exports